import OffboardingForm from './OffboardingForm';

export default OffboardingForm;
